import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { MdSchool } from "react-icons/md";

import { TrainingContext } from '../services/Training'

const TrainingCard = ({ name, reference, id }: any) => {
  const navigate = useNavigate()
  const [, setTrainingContext] = useContext(TrainingContext);

  const onClick = () => {
    setTrainingContext({ name, id, reference })
    navigate(`/training/${id}`)
  }

  return (
    <div className="shadow-lg p-4 w-80 bg-white m-2 hover:scale-105 cursor-pointer" onClick={onClick}>
      <div className="flex">
        <MdSchool className="bg-rose-500 rounded-full h-10 w-10 p-2" color="white" />
        <div className="flex-1 ml-2 truncate overflow-hidden">
          <h6 className="text-slate-600 font-medium capitalize m-0 p-0">
            {name}
          </h6>
          <p className="text-slate-400 text-xs">{reference}</p>
        </div>
      </div>
    </div>
  );
}

export default TrainingCard